import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import {  GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { environment } from 'src/environments/environment';
import { TravelReimbursementModel } from 'common/models/page-models/travel-reimbursement/travel-reimbursement-data.model';
import { TravelReimbursementListingModel, TravelReimbursementGridPostParams } from 'common/models/page-models/travel-reimbursement/travel-reimbursement-grid.model';
import { parseDate } from 'ngx-bootstrap/chronos';



@Injectable({
    providedIn: 'root'
})
export class TravelReimbursementGridDataService extends GridDataService<TravelReimbursementListingModel, TravelReimbursementModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.getTravelReimbursementListForStudent, http, ss);
    }

    createInstance(): TravelReimbursementListingModel {
        return new TravelReimbursementListingModel();
    }

    override getDeleteUrl(): string {
        return environment.apiUrl+API_URL.deleteTravelReimbursement;
    }

    override getGridParams(param): GridPostParams {
        return new TravelReimbursementGridPostParams();
    }


    override modifyGridPostParams(queryParams) {
        return {};
    }


    override transformDataModel(apiRes: any, param:string) {
        super.transformDataModel(apiRes, param);
        apiRes[param].forEach(element => {
            element.approved = element.isApproved === '0' ? false : true;
            // element.travelDocument =  element.travelDoc !== "" ? '-' : apiRes['details']['studentUploadedFilepath'] + element.travelDoc;
            element.travelDocument = element.travelDoc === "" || element.travelDoc === null ?  '-' : element.travelDoc ;

            element.endDate = element.travelDoc === '' || element.travelDoc === "" || element.travelDoc === null ? '-' : new Date(element.travelEndDate).toLocaleDateString();
            element.startDate = element.travelDoc === '' || element.travelDoc === "" || element.travelDoc === null ? '-' : new Date(element.travelStartDate).toLocaleDateString();
            element['uploadDate'] = element.travelDoc === "" || element.travelDoc === "" || element.travelDoc === null ? '-' : new Date(element.travelDocUploadedDate).toLocaleDateString();
            element.travelDocUploadStartDate = new Date(element.travelDocUploadStartDate);
            element.travelDocUploadEndDate = new Date(element.travelDocUploadEndDate);
            element.docStartDate = new Date(element.travelDocUploadStartDate).toLocaleDateString();
            element.docEndDate = new Date(element.travelDocUploadEndDate).toLocaleDateString();
            element.travelenddate = new Date(element.travelEndDate).toLocaleDateString();
            element.travelstartdate = new Date(element.travelStartDate).toLocaleDateString();
            element.uploadeddate = new Date(element.travelDocUploadedDate).toLocaleDateString();

            element.travelTitleOrRemark = element.travelTitleOrRemark === '' || element.travelTitleOrRemark === null ? '-' : element.travelTitleOrRemark;
        //    console.log(element.travelDocUploadStartDate)
        //    console.log(element.travelDoc)
           element.travelDoc = element.travelDoc === '' ? "" : element.travelDoc;
            const currentDate = new Date().setHours(0, 0, 0, 0);  // Set the current time to the start of the day for comparison

            const startDate = element.travelDocUploadStartDate.setHours(0, 0, 0, 0);
            const endDate = element.travelDocUploadEndDate.setHours(0, 0, 0, 0);
           // console.log(currentDate)
            // const startDate =
            element.showEdit = (currentDate >= startDate) && (currentDate <= endDate);
        });
        // console.log(apiRes,'Datee');
        
        return apiRes;
    }

    // override transformDataModel(apiRes: any, param:string) {
    //     super.transformDataModel(apiRes, param);
    
        // Check if data exists for the parameter
        // if (apiRes[param] && Array.isArray(apiRes[param])) {
        //     apiRes[param].forEach(element => {

        //         // Apply the necessary transformations here
        //         element.approved = element.isApproved === '0' ? false : true;
        //         element.travelDocument = element.travelDoc === "" ? '-' : apiRes['assignment_detail']['studentUploadedFilepath'] + element.travelDoc;
        //         element.endDate = element.travelDoc === "" ? '-' : new Date(element.travelEndDate).toLocaleDateString();
        //         element.startDate = element.travelDoc === "" ? '-' : new Date(element.travelStartDate).toLocaleDateString();
        //         element.uploadDate = element.travelDoc === "" ? '-' : new Date(element.travelDocUploadedDate).toLocaleDateString();
        //         element.travelDocUploadStartDate = new Date(element.travelDocUploadStartDate);
        //         element.travelDocUploadEndDate = new Date(element.travelDocUploadEndDate);
        //         element.docStartDate = new Date(element.travelDocUploadStartDate).toLocaleDateString();
        //         element.docEndDate = new Date(element.travelDocUploadEndDate).toLocaleDateString();
        //         element.travelTitleOrRemark = element.travelTitleOrRemark === '' ? '-' : element.travelTitleOrRemark;
        //         element.travelDoc = element.travelDoc === '' ? null : element.travelDoc;
    
        //         const currentDate = new Date().setHours(0, 0, 0, 0);  // Set current date to the start of the day
        //         const startDate = element.travelDocUploadStartDate.setHours(0, 0, 0, 0);
        //         const endDate = element.travelDocUploadEndDate.setHours(0, 0, 0, 0);
    
        //         // Set showEdit based on date comparison
        //         element.showEdit = (currentDate >= startDate) && (currentDate <= endDate);
        //         console.error('Data not found or apiRes[param] is empty');

        //     });
        // } else {
        //     console.error('Data not found or apiRes[param] is empty');
        // }


    
    //     return apiRes;
    // }
    



    override getDeletePayload(data) {
        let payload = {
            id : data.id
        }
        // payload={multi_check:data.id}

        // payload = data;
        return payload;
      }
}
